import { render, staticRenderFns } from "./FacesUpload.vue?vue&type=template&id=3eec4fb4&scoped=true&"
import script from "./FacesUpload.vue?vue&type=script&lang=js&"
export * from "./FacesUpload.vue?vue&type=script&lang=js&"
import style0 from "./FacesUpload.vue?vue&type=style&index=0&id=3eec4fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec4fb4",
  null
  
)

export default component.exports